import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Box, IconButton } from "@mui/material";
import { IconAndLabel, TitleSubTitle } from "@platformx/utilities";

import { useState } from "react";

const MIN__ITEMS_TO_SHOW = 4;

interface PopulatedItem {
  title: string;
  name: string;
}

export const DraggableItems = ({
  state,
  setState,
  name,
  populatedItems = [],
}: {
  state: any;
  setState: any;
  name: string;
  populatedItems: PopulatedItem[];
}) => {
  const [showAll, setShowAll] = useState(false);
  const renderItems = showAll ? populatedItems : populatedItems?.slice(0, MIN__ITEMS_TO_SHOW);

  const onDeleteOption = (id) => {
    const tempQue = state[name].filter((item) => item.content_name !== id);
    setState({ ...state, [name]: tempQue });
  };

  return (
    <Box sx={{ mb: "10px" }}>
      <Box>
        {renderItems?.map((item) => {
          return (
            <Box key={item?.name} sx={{ padding: "5px 5px 5px 0px" }}>
              <Box
                className='category-container'
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  border: "solid 1px #ced3d9",
                  borderRadius: "5px",
                  padding: "13px 14px",
                  width: "100%",
                }}>
                <Box
                  sx={{
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}>
                  <TitleSubTitle
                    subTitle={item?.title}
                    titleVariant='p4regular'
                    subTitleVariant='h6regular'
                  />
                </Box>
                <Box>
                  <IconButton
                    onClick={() => onDeleteOption(item?.name)}
                    data-testid='content-delete-option'
                    aria-label={item?.title ? `Remove ${item.title}` : "Remove"}
                    sx={{ width: "32px", height: "32px" }}>
                    <CloseOutlinedIcon sx={{ color: "#6e7191" }} />
                  </IconButton>
                </Box>
              </Box>
            </Box>
          );
        })}
      </Box>
      {/* </DragAndDrop> */}
      {state[name]?.length > MIN__ITEMS_TO_SHOW && (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          {showAll ? (
            <IconAndLabel
              icon={<VisibilityIcon />}
              label='View less'
              handelClick={setShowAll}
              funcProp={false}
            />
          ) : (
            <IconAndLabel
              icon={<VisibilityIcon />}
              label='View all'
              handelClick={setShowAll}
              funcProp
            />
          )}
        </Box>
      )}
    </Box>
  );
};
